// index.js
// Navbar component

// Imports
import React from 'react';
import { Navbar as BpNavbar, Popover, Position, NavbarGroup, NavbarHeading, NavbarDivider, Button, Alignment } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import withRouter from 'react-router-dom/withRouter';
import LocalStorage from '../../config/LocalStorage';
import SystemMenu from './SystemMenu';

// Component Class
// Shows a navigation bar
class Navbar extends React.Component {
  // Changes the current router location
  changeLocation = (path) => {
    this.props.history.push(path);
  }
  
  // Called whenever the hidden file input for loading state is changed
  onLoadStateChange = (event) => {
    var file = event.target.files[0];
    var reader = new FileReader();
    
    reader.onload = function(){
      LocalStorage.RestoreState(reader.result);
    }
    reader.readAsText(file);
  };

  // Renders Component
  render() {
    return (
      <BpNavbar>
        <NavbarGroup align={Alignment.LEFT}>
          <NavbarHeading><b>Carlinhos</b></NavbarHeading>
          <NavbarDivider />
          <Button className="pt-minimal" icon="home" text="Novidades" onClick={() => { this.changeLocation('/'); }}/>
          <Button className="pt-minimal" icon="barcode" text="Produtos" onClick={() => { this.changeLocation('/product'); }}/>
          <Button className="pt-minimal" icon="user" text="Clientes" onClick={() => { this.changeLocation('/client'); }}/>
          <Button className="pt-minimal" icon="dollar" text="Pedidos" onClick={() => { this.changeLocation('/order'); }}/>
          <Button className="pt-minimal" icon="chart" text="Gráficos" onClick={() => { this.changeLocation('/chart'); }}/>
          <Button className="pt-minimal" icon="document" text="Relatórios" onClick={() => { this.changeLocation('/report'); }}/>
        </NavbarGroup>
        <NavbarGroup align={Alignment.RIGHT}>
          <Popover content={<SystemMenu {...this.props}/>} position={Position.BOTTOM}>
            <Button name="system-menu" className="pt-minimal" icon="cog" text="" />
          </Popover>
          <input type="file" id="file_loadstate" name="upload" style={{display: 'none'}} accept="application/json" onChange={this.onLoadStateChange} />
        </NavbarGroup>
      </BpNavbar>
    );
  }
}

// Required Properties
Navbar.propTypes = {
  products: PropTypes.object.isRequired,
  prevOrders: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  closeOrder: PropTypes.func.isRequired,
  reopenOrder: PropTypes.func.isRequired,
}

// Exports
export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js